import * as caApi from "./caApi";
import * as eApi from "./eApi";
import * as eApiRecord from "./eApiRecord";
import * as eChapter from "./eChapter";
import * as module from "./module";
import * as transactionMain from "./transactionMain";

export const esca = {
  caApi,
  eApi,
  eApiRecord,
  eChapter,
  module,
  transactionMain,
};
